export const STEP_COMPANY = [
    {
        step: 1,
        name: 'Empresa',
    },
    {
        step: 2,
        name: 'Perfil',
    },
    {
        step: 3,
        name: 'Persona',
    },
];
